module.exports = __webpack_public_path__ + "img/it-verantwortlicher.d04841c9.png";